/**
 * Catégories des socles fit-culturel ANTÉRIEURS, conservées pour la seule
 * relecture (plan référentiel §3.4).
 *
 * LE SOCLE LUI-MÊME A DÉMÉNAGÉ : les 23 items imposés vivent désormais dans
 * [convex/referentiel/socleFitCulturel.ts](../../../convex/referentiel/socleFitCulturel.ts),
 * parce que c'est le backend qui pose le référentiel à la création de la
 * campagne. Ne restent ici que les rubriques des socles précédents : les
 * campagnes configurées sous ces socles portent ces clés dans leur snapshot
 * (§3.2) et, sans elles, leurs rapports afficheraient `organisation` brut au lieu
 * de « Organisation du travail ».
 */
export const FIT_CULTUREL_CATEGORIES = [
  { cle: "organisation", label: "Organisation du travail" },
  { cle: "relations", label: "Relations et collectif" },
  { cle: "management", label: "Management" },
  { cle: "developpement", label: "Développement professionnel" },
  { cle: "reconnaissance", label: "Reconnaissance et rétribution" },
  { cle: "sens", label: "Sens et exigence" },
] as const;

export type FitCulturelCategorie =
  (typeof FIT_CULTUREL_CATEGORIES)[number]["cle"];

/** Libellé lisible d'une catégorie d'un socle antérieur, `undefined` si inconnue. */
export function labelCategorieFitCulturel(cle: string): string | undefined {
  return FIT_CULTUREL_CATEGORIES.find((c) => c.cle === cle)?.label;
}
